import { render, staticRenderFns } from "./AccountManage.vue?vue&type=template&id=609838f4&scoped=true"
import script from "./AccountManage.vue?vue&type=script&lang=js"
export * from "./AccountManage.vue?vue&type=script&lang=js"
import style0 from "./AccountManage.vue?vue&type=style&index=0&id=609838f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609838f4",
  null
  
)

export default component.exports